import React from 'react'

import { getHeaderStyled, IHProps } from './H.styled'

const HStyled = getHeaderStyled('h3', {
  fontSize: 1.375,
  fontWeight: 'normal',
  lineHeight: 1.27,
  letterSpacing: 0.3,
})

export class H3 extends React.PureComponent<
  IHProps & React.HtmlHTMLAttributes<HTMLHeadingElement>
> {
  public render() {
    return <HStyled {...this.props} />
  }
}
